const updateDocument = (db, document) =>
  db
    .get(`/${document._id}?t=${Date.now()}`)
    .then(({ data }) =>
      db.put(
        `/${document._id}`,
        {
          ...data,
          ...document
        }
      )
    )
    .then(({ data: { id, rev } }) => ({ id, rev }))

  export default updateDocument



// WEBPACK FOOTER //
// ./src/helpers/databases/updateDocument.js